import { BdkTooltip } from '@breuni-ui/bdk-tooltip';
import { safeDefine } from '@breuni-ui/safe-define';
import { mediaQuery } from '../../scripts/lib/mediaQuery.js';

class EntsTooltip extends BdkTooltip {
  static get properties() {
    return {
      disableOnMobile: { type: Boolean, attribute: 'disable-tooltip-on-mobile' },
    };
  }

  connectedCallback() {
    if (this.disableOnMobile && mediaQuery.checkIfTouchDevice()) {
      // Don't create tooltip on mobile only when disabled
      this.style.display = 'none';
      return;
    }
    super.connectedCallback();
  }
}

safeDefine('ents-tooltip', EntsTooltip);
